import {writable} from 'svelte/store';
import {v4 as uuid4} from 'uuid';
import _ from 'lodash';

export const modals = writable([]);

export const showModal = (component, {
  id = null,
  modalProps = {},
  contentProps = {}
} = {}) => {
  id = id || uuid4();
  modals.update(v => [...v, {
    id,
    component,
    modalProps: {
      ...modalProps,
      close: () => {
        hideModal(id);
      }
    },
    contentProps
  }]);
};

export const hideModal = id => {
  modals.update(val => _.filter(val, v => v.id !== id));
};